/**
 * bundle-baseline.ts - GENERATED by `node scripts/measure-budget.mjs --write`.
 *
 * Do not edit by hand: regenerate it after any dependency or build change so the performance
 * panel always quotes the payload that was actually measured.
 */
export const BUNDLE_BASELINE = {
    generatedAt: "2026-10-16",
    firstScreenGzipKb: 76.1,
    gameChunkGzipKb: 119.3,
    wasmGzipKb: 896.2,
    entryGzipKb: 72.3
} as const;
